import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Supplier } from '../_models/supplier';
import { environment } from '../../../environments/environment';

@Injectable()
export class SupplierService {
  private apiBaseUrl = environment.apiBaseUrl;
  list = [];

  constructor(private http: HttpClient) {}

  getSuppliers(excludes = false): Observable<Supplier[]> {
    // let excludesList = [];
    // let excludesAppend = '';
    // if (excludes) {
    //     excludesList = ['customers','addresses', 'certifications']
    //     excludesList.forEach(item => {
    //         excludesAppend += '&excludes=' + item
    //     });
    // }

    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/suppliers').pipe(
      map((response) => {
        this.list = response;
        return response;
      })
    );
  }

  getSupplier(id: number): Observable<Supplier> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/suppliers/' + id)
      .pipe(map((response) => response));
  }

  saveSupplier(supplierItem): Observable<Supplier> {
    const supplier = { ...supplierItem };
    delete supplier.lastUpdated;
    delete supplier.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    supplier.companyId = companySelected ? companySelected.id : null;

    if (supplier.user != null && supplier.user.id != null) {
      supplier.user = { id: supplier.user.id };
    }
    if (supplier.id) {
      return this.http
        .put<Supplier>(this.apiBaseUrl + 'api/private/v1/suppliers/' + supplier.id, supplier)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Supplier>(this.apiBaseUrl + 'api/private/v1/suppliers/', supplier)
        .pipe(map((response) => response));
    }
  }

  deleteSupplier(id: number): Observable<Supplier> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/suppliers/' + id).pipe(
      map((response) => {
        return { id } as Supplier;
      })
    );
  }

  getLocalSupplierById = (id: number): Supplier => {
    let supplier: Supplier;
    for (const item of this.list) {
      if (item.id === id) {
        supplier = item;
        break;
      }
    }
    return supplier;
  };
}
